import { ArrowRight } from "lucide-react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { NoirBar, NoirFooter } from "./NoirChrome";
import "./MarketingPage.css";
import "./LegalPage.css";

// Nothing runs here: the public catch-all, and the same message inside the signed-in shell.

const SENTENCE = "There is no page at this address. It may have moved, or the link was never right.";

export function NotFoundPage() {
  useEffect(() => {
    document.title = "Not found · LoopGroup";
  }, []);

  return (
    <div className="noir legal not-found">
      <NoirBar />
      <main className="legal__main not-found__main">
        <section className="not-found__copy" aria-labelledby="not-found-title">
          <p className="noir__eyebrow">404 · Not found</p>
          <h1 id="not-found-title" className="noir__display">Nothing runs here.</h1>
          <p>{SENTENCE}</p>
          <div className="not-found__actions">
            <Link className="noir__cta" to="/app">See your loops <ArrowRight size={18} aria-hidden="true" /></Link>
            <Link className="noir__navlink" to="/">Back to LoopGroup <ArrowRight size={15} aria-hidden="true" /></Link>
          </div>
        </section>
      </main>
      <NoirFooter />
    </div>
  );
}

/** Unknown /app/* paths: the same words inside the app shell, in the app's own tokens. */
export function AppNotFound() {
  useEffect(() => {
    document.title = "Not found · LoopGroup";
  }, []);

  return (
    <div className="page not-found-app">
      <p className="eyebrow">404 · Not found</p>
      <h1>Nothing runs here.</h1>
      <p>{SENTENCE}</p>
      <div className="not-found-app__actions">
        <Link className="button button--primary button--large" to="/app">See your loops <ArrowRight size={16} aria-hidden="true" /></Link>
        <Link className="text-link" to="/">Back to LoopGroup <ArrowRight size={14} aria-hidden="true" /></Link>
      </div>
    </div>
  );
}
